



































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import FieldInput from '@/components/form/FieldInput.vue';
import MultipleFieldInput from '@/components/form/MultipleFieldInput.vue';
import {
  TCreativeFormOptions,
  TCreativeMultipleFields,
  TDictionary,
} from '@/types';
import {
  getCreativeFormOptions,
  getMultipleFieldsInit,
} from '@/configs/creativeConfigs';
import { ICreative } from '@/types/campaign/creatives';
import {
  checkMultipleFieldsHaveErrors,
  getCreativeStorePath,
} from '@/helpers/creativeHelpers';
import { getTranslate } from '@/helpers/translateHelpers';
import CreativeService from '@/services/CreativeService';

export default Vue.extend({
  name: 'CreateCreativeFields',
  components: { FieldInput, MultipleFieldInput },

  props: {
    currentId: {
      type: String,
      required: true,
    },
  },

  created() {
    for (const id of this.creativeIds) {
      this.$set(this.multipleFields, id, getMultipleFieldsInit());
    }
  },

  computed: {
    ...mapGetters({
      editCreatives: getCreativeStorePath('getEditCreatives'),
    }),
    creativeIds(): Array<string> {
      return this.editCreatives.allIds;
    },
    currentCreative(): ICreative {
      return this.editCreatives.byId[this.currentId];
    },
    getCreativeFormOptions(): TCreativeFormOptions {
      return getCreativeFormOptions();
    },
  },

  methods: {
    validate(): boolean {
      CreativeService.validateCreatives(this.editCreatives.byId);
      CreativeService.validateMultipleFields(this.multipleFields);

      return checkMultipleFieldsHaveErrors(this.multipleFields);
    },
    getTranslate(path: string): string {
      return getTranslate(path);
    },
    resetError(fieldName) {
      if (this.currentCreative.errors[fieldName].length) {
        this.currentCreative.errors[fieldName] = [];
      }
    },
    apply() {
      CreativeService.applyNewCreatives(
        this.editCreatives.byId,
        this.multipleFields
      );
    },
    changeField(fieldName: string) {
      CreativeService.fillCreativesField(this.editCreatives, fieldName);
    },
    changeMultipleFields(fieldName: string) {
      CreativeService.fillMultipleFields(this.multipleFields, fieldName);
    },
  },

  data() {
    return {
      multipleFields: {} as TDictionary<TCreativeMultipleFields>,
    };
  },
});
